module.exports = __webpack_public_path__ + "img/precision-hawk-logo.28981f31.jpg";